module.exports = __webpack_public_path__ + "static/media/PTC.a24ceafb.png";